import { render, staticRenderFns } from "./order-delivery-by-renter.vue?vue&type=template&id=096b01a6&scoped=true&lang=pug&"
import script from "./order-delivery-by-renter.vue?vue&type=script&lang=js&"
export * from "./order-delivery-by-renter.vue?vue&type=script&lang=js&"
import style0 from "./order-delivery-by-renter.vue?vue&type=style&index=0&id=096b01a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096b01a6",
  null
  
)

export default component.exports